import ApiService from "@/core/services/ApiService";

class FileService {

    //solo para lista de archivos y tipos
    public static getFiles(id: any, action: any) {
        ApiService.setHeader()
        return ApiService.get(`api/file/${id}`, action)
    }

    public static getFiles2(id: any, action: any, params:any) {
        ApiService.setHeader()
        return ApiService.post(`api/file/${id}/${action}`, params)
    }

}

export default FileService;